(function () {
  document.documentElement.classList.add('js');
  var main = document.getElementById('mainImg');
  var thumbs = document.querySelectorAll('.thumbs button');
  thumbs.forEach(function (b) {
    b.addEventListener('click', function () {
      thumbs.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      b.setAttribute('aria-pressed', 'true');
      if (main) { main.removeAttribute('srcset'); main.src = b.dataset.src; }
    });
  });

  var swipe = document.getElementById('swipe');
  var dots = document.querySelectorAll('#swipeDots i');
  if (swipe && dots.length) {
    var t;
    swipe.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(swipe.scrollLeft / swipe.clientWidth);
        dots.forEach(function (d, k) { d.className = k === i ? 'on' : ''; });
      }, 60);
    }, { passive: true });
  }
  window.wamaoSwipeTo = function (id) {
    if (!swipe) return;
    var imgs = swipe.querySelectorAll('img');
    for (var k = 0; k < imgs.length; k++) {
      if (String(imgs[k].dataset.id) === String(id)) { swipe.scrollTo({ left: k * swipe.clientWidth, behavior: 'smooth' }); break; }
    }
  };

  var dataEl = document.getElementById('variantData');
  var form = document.getElementById('productForm');
  if (!dataEl || !form) return;
  var variants = JSON.parse(dataEl.textContent);
  var select = document.getElementById('variantSelect');
  var btn = document.getElementById('addBtn');
  var price = document.getElementById('priceNow');
  var fmt = function (cents) { var d = cents / 100; return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2)); };

  function update() {
    var sets = form.querySelectorAll('fieldset[data-option-index]');
    if (!sets.length) return;
    var chosen = [];
    sets.forEach(function (fs) { var c = fs.querySelector('input:checked'); chosen.push(c ? c.value : null); });
    var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
    if (!v) { btn.disabled = true; btn.textContent = btn.dataset.unavailable || 'Unavailable'; return; }
    select.value = String(v.id);
    price.textContent = fmt(v.price);
    btn.disabled = !v.available;
    btn.textContent = v.available ? (btn.dataset.add || 'Add to cart · __P__').replace('__P__', fmt(v.price)) : (btn.dataset.soldout || 'Sold out');
    if (v.featured_image && main) { main.removeAttribute('srcset'); main.src = v.featured_image.src; }
    if (v.featured_image) window.wamaoSwipeTo(v.featured_image.id);
    var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
  }
  (function () {
    var cur = variants.find(function (x) { return String(x.id) === String(select.value); });
    if (cur && cur.featured_image && swipe) {
      var imgs = swipe.querySelectorAll('img');
      for (var k = 0; k < imgs.length; k++) if (String(imgs[k].dataset.id) === String(cur.featured_image.id)) {
        var go = function (n) { return function () { swipe.scrollLeft = n * swipe.clientWidth; dots.forEach(function (d, j) { d.className = j === n ? 'on' : ''; }); }; }(k);
        if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
        break;
      }
    }
  })();
  form.addEventListener('change', function (e) { if (e.target.name && e.target.name.indexOf('option-') === 0) update(); });
})();
